import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "app-input-button",
    standalone: true,
    imports: [CommonModule],
    templateUrl: "./input-button.component.html",
    styleUrls: ["./input-button.component.scss"],
})
export class InputButtonComponent {
    @Input() type: "primary" | "outlined" | "floating" = "primary";
    @Input() disabled: boolean = false;
    @Input() class: string = "";
    @Input() icon: string = "";
    @Output() clicked = new EventEmitter<void>();

    onClick() {
        if (!this.disabled) {
            this.clicked.emit();
        }
    }

    get buttonClasses() {
      return {
        'input-btn': true,
        'primary-btn': this.type === 'primary',
        'outlined-btn': this.type === 'outlined',
        'floating-btn': this.type === 'floating',
        'disabled': this.disabled
      }
    }
}
